import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import {
    IRequestData,
    IHorizon,
    IFilterHorizons,
} from '../../../types';
import { AuthContext } from '../../../contexts/Auth/AuthContext';
import apiService from '../../../services/apiService';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';

interface IHorizonProps {
    examId: string | undefined
    horizon: IHorizon
    horizonFilters: IFilterHorizons
    renewHorizon: (data: Array<IHorizon> | undefined) => void
}

export default function HorizonTransitionItem(props: IHorizonProps) {
    const styles = useStyles();
    const auth = React.useContext(AuthContext);
    const [transitionForm, setTransitionForm] = useState<string>('0');
    const [transitionSharpness, setTransitionSharpness] = useState<string>('0');
    const [transitionUpdate, setTransitionUpdate] = useState<boolean>(false);

    async function updateHorizon() {
        if (auth !== undefined && props.examId !== undefined && props.horizon !== undefined) {
            let request_data: IRequestData = {
                horizon_id: props.horizon.id,
                exam_id: parseInt(props.examId),
            };

            if (
                transitionForm !== null &&
                transitionForm !== '0' &&
                props.horizon.transition_form !== `${transitionForm}`
            ) {
                request_data['transition_form'] = `${transitionForm}`;
            }
            if (
                transitionSharpness !== null &&
                transitionSharpness !== '0' &&
                props.horizon.transition_sharpness !== `${transitionSharpness}`
            ) {
                request_data['transition_sharpness'] = `${transitionSharpness}`;
            }

            try {
                await apiService.put(
                    'exams/horizon',
                    request_data
                ).then((response) => {
                    if (response !== undefined && response.status === 200) {
                        props.renewHorizon(response.data.data as Array<IHorizon>);
                    }
                }).catch(() => {
                });
            } catch (e) {
            }
        }
    }

    useEffect(() => {
        if (transitionUpdate === true) {
            updateHorizon();
            setTransitionUpdate(false);
        }
        return () => setTransitionUpdate(false);
        // eslint-disable-next-line
    }, [transitionUpdate]);

    useEffect(() => {
        if (props.horizon !== undefined) {
            setTransitionForm((props.horizon.transition_form === null ? '0' : props.horizon.transition_form));
            setTransitionSharpness((props.horizon.transition_sharpness === null ? '0' : props.horizon.transition_sharpness));
        }
        // eslint-disable-next-line
    }, [props]);

    return (
        <Grid 
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            key={`${props.horizon.id}${props.horizon.name}transition_form`}
            className={styles.view_horizon_transition}
        >
            <Grid item xs={12} className={styles.view_horizon_transition_title}>
                <Typography className={styles.text_horizon_transition}>
                    <strong>{props.horizon.name}</strong>
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_transition_subtitle}>
                <Typography className={styles.text_horizon_transition_subtitle}>
                    Forma
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_transition_subtitle}>
                <TextField
                    className={styles.picker_select_type}
                    select
                    value={transitionForm ? transitionForm : "0"}
                    defaultValue={'0'}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setTransitionForm(`${event.target.value}`);
                        setTransitionUpdate(true);
                    }}
                >
                    <MenuItem className={styles.picker_select_item} key={'0'} value={'0'}>Selecione</MenuItem>
                    {props.horizonFilters.transition_form.map((element, key) => (
                        <MenuItem className={styles.picker_select_item} key={key} value={`${key + 1}`}>{`${element}`}</MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_transition_subtitle}>
                <Typography className={styles.text_horizon_transition_subtitle}>
                    Grau
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_transition_subtitle}>
                <TextField
                    className={styles.picker_select_type}
                    select
                    value={transitionSharpness ? transitionSharpness : "0"}
                    defaultValue={'0'}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setTransitionSharpness(`${event.target.value}`);
                        setTransitionUpdate(true);
                    }}
                >
                    <MenuItem className={styles.picker_select_item} key={'0'} value={'0'}>Selecione</MenuItem>
                    {props.horizonFilters.transition_sharpness.map((element, key) => (
                        <MenuItem className={styles.picker_select_item} key={key} value={`${key + 1}`}>{`${element}`}</MenuItem>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    );
}